import React from 'react';

const Logo = ({ className = '', size = 'lg' }) => {
  const sizes = { sm: 'text-lg', md: 'text-xl', lg: 'text-2xl' };
  return (
    <span className={`inline-flex items-center gap-1.5 font-sans font-bold tracking-tight text-slate-900 ${sizes[size]} ${className}`}>
      <span className="inline-flex items-center justify-center w-7 h-7 rounded-lg bg-mint-500 text-slate-900 font-bold text-sm">L</span>
      <span>LVE <span className="text-mint-600">Social</span></span>
    </span>
  );
};

export default Logo;
